import { mainApi } from '@/lib';
import { IntegrationsResponse, User } from '@/types';
import Cookies from 'js-cookie';

export async function fetchUser(token: string | null): Promise<User> {
    const localToken = token ?? Cookies.get('token');
    if (!localToken) throw new Error('No authentication token found');

    const { data: user } = await mainApi.get('v1/users/get_user', {
        headers: { Authorization: `Bearer ${localToken}` },
    });

    return user as User;
}

export async function fetchUserIntegrations(): Promise<IntegrationsResponse> {
    const { data } = await mainApi.get<IntegrationsResponse>('v1/integrations');
    return data;
}

export async function updatePinnedNavigation(pinned: { id: string }[]): Promise<void> {
    await mainApi.post('v1/users/navigation-update', { pinned_navigation: pinned });
}

/**
 * Response from payment method lookup API
 */
export interface PaymentMethodLookupResponse {
    other_emails: string[];
}

/**
 * Check if a payment method is already used by another account
 * Used for fraud prevention during subscription creation
 */
export async function getExistingAccountsWithPaymentMethod(
    paymentMethodId: string
): Promise<PaymentMethodLookupResponse> {
    const { data } = await mainApi.get<PaymentMethodLookupResponse>('/v1/users/payment-method-lookup', {
        params: { payment_method_id: paymentMethodId },
    });
    return data;
}
